<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/customer/quality_control/destination/list_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_quality_control_destination_list_templates_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      container_id: container_id,
      customer_id: customer_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter?.name,
      container?.container_code,
      quality_template?.name
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info :container="container"></container-info>

    <div class="mt-6">
      <h1 class="page-title">
        <i class="fa-solid fa-list-ul"></i><span class="space-icon"></span>
        {{ $t("labels.quality_inspects_title") }}
      </h1>

      <div class="mt-8 flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default :label="quality_inspects.length+' '+$t('labels.total_number_inspects')" />
        </div>
        <new-button @click.prevent="goToNewInspection()" :label='$t("labels.new_button")' />
      </div>

      <inspection-details
        v-if="quality_template"
        :quality_template="quality_template"
        :quality_inspects="quality_inspects"
        :goToShow="goToShowQualityInspect"
      ></inspection-details>
      <loading-message v-else />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/quality_control/container/list_inspects.js";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import ContainerInfo from "@/components/views/customer/quality_control/destination/ContainerInfo.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import InspectionDetails from "@/components/views/customer/quality_control/destination/InspectionDetails.vue";

export default {
  name: "ListInspects",
  components: {
    GoBackLink,
    ContainerInfo,
    BreadCrumbs,
    InspectionDetails
  },
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      container: {},
      quality_inspects: [],
      quality_template: null,
      quality_templates: []
    };
  },
  props: {
    customer_id: { required: true },
    agro_exporter_id: {
      required: true
    },
    container_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    current_tab: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporter();
      await this.fetchContainer();
      await this.fetchTemplate();
      await this.fetchInspects();
      this.load_data_general = true;
    },
    inspectsByTemplate: function (current_tab_id) {
      return this.quality_inspects.filter(
        eq_inspect => eq_inspect.quality_template_id === current_tab_id
      );
    },
    maxSamplings: function (arr) {
      return Math.max(...arr.map(eq_inspect => eq_inspect.samplings));
    },
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id
      });
      this.agro_exporter = response.data;
    },
    downloadRepXlsx: async function () {
      try {
        let response = await Requester.downloadQualityInspectsRepXlsx({
          container_id: this.container_id,
          quality_template_id: this.quality_template.id
        });

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let name = this.quality_template?.name;
        if (name) name = `${name.split(" ").join("_")}.xlsx`;
        fileLink.setAttribute("download", name ?? "reporte.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id
      });
      this.container = response.data;
    },
    fetchInspects: async function () {
      let response = await Requester.fetchInspects({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.quality_inspects = response.data;
    },
    fetchTemplate: async function () {
      let response = await Requester.fetchTemplate({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.quality_template = response.data;
    },
    switchTab: function (index) {
      if (this.current_tab) return Number(this.current_tab) === index;
      return index == 0;
    },
    goToShowQualityInspect: function (quality_inspect) {
      this.$router.push({
        name: "customer_quality_control_destination_show_inspect_path",
        params: {
          container_id: this.container_id,
          quality_inspect_id: quality_inspect.id,
          agro_exporter_id: this.agro_exporter_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    },
    goToNewInspection: function () {
      this.$router.push({
        name: "customer_quality_control_destination_new_inspect_path",
        params: {
          container_id: this.container_id,
          quality_template_id: this.quality_template?.id,
          agro_exporter_id: this.agro_exporter_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    }
  }
};
</script>
